var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"lol-end":""}},[_c('HomeHeader'),_c('DiscordSection'),_c('SpecialLeague'),_c('CommunityLeague',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]}),_c('HistorySection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }